import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton'
import Item from './Item/Item';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import {connect} from 'react-redux'
import SelectComp from '../../utils/Select/SelectComp';

const ConfPartner = (props) => {
    const [formData,setFormData] = React.useState({
        userId: props.user._id,
        name: "",
        contactNum:"",
        location: "",
        address: "",
        status: "Active",
        partnerId: "",
        type: "Dealer",
        discount: "",
        isTrusted:"No"
    });

    const [loading,setLoading] = React.useState(false)
    const [err,setErr] = React.useState({contactNum: false,name: false,location: false,address: false,discount: false})
  

    React.useEffect(() => {
        if(props.type == "EDIT") {
            setFormData({...formData,...props.partner,partnerId: props.partner._id})
        } 
    },[props.partner]);
    
    const validate = () => {
        let validData = true;
        let error = {contactNum: false,name: false,location: false,address: false,discount: false}
        setErr({...err,...error});
        Object.keys(error).map(key => {
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            }
            if(key == "contactNum" && formData[key].toString().length != 10) {
                error[key] = "Enter Valid Phone Number";
                validData = false
            }
        })
        setErr({...error});

        return validData;
    }

    const onSubmit = () => {
        if(validate()) {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editPartner" : "/addPartner"

            axios({
                method: "post",
                url: url,
                data: {
                    ...formData, 
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({userId: props.user._id,name: "",contactNum:"",location: "",address: "",status: "",partnerId: "",type: "Dealer",isTrusted:"No"})
                } else {
                    props.setAlert("Something went wrong")
                    setLoading(false)
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong")
            })
        }
    }
    let btnText = props.type == "EDIT" ? "Update Partner" : "Add Partner";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'lg'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Partner Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Name"
                                value={formData.name}
                                onBlur={(e) => setFormData({...formData,name: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,name: e.target.value})}
                                error={err.name}
                                helperText={err.name}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Contact Number"
                                value={formData.contactNum}
                                type="text"
                                onBlur={(e) => setFormData({...formData,contactNum: e.target.value.replace(/\D/,'').trim()})}
                                onChange={(e) => {
                                    e.target.value.length <= 10 && setFormData({...formData,contactNum: e.target.value.replace(/\D/,'')})
                                }}
                                error={err.contactNum}
                                helperText={err.contactNum}
                            /> 
                        </div>

                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Location"
                                value={formData.location} 
                                onBlur={(e) => setFormData({...formData,location: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,location: e.target.value})}
                                error={err.location}
                                helperText={err.location}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Address"
                                value={formData.address}
                                onBlur={(e) => setFormData({...formData,address: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,address: e.target.value})}
                                error={err.address}
                                helperText={err.address}
                            /> 
                        </div> 
                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Partner Type"
                                value={formData.type} 
                                onChange={(e) => setFormData({...formData,type: e.target.value})}
                                options={["Dealer","Distributor"]}
                                values={["Dealer","Distributor"]}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Discount (%)"
                                value={formData.discount}
                                onBlur={(e) => setFormData({...formData,discount: e.target.value.replace(/\D/,'').trim()})}
                                onChange={(e) => {
                                    e.target.value <= 100 && setFormData({...formData,discount: e.target.value.replace(/\D/,'')})
                                }}
                                error={err.discount}
                                helperText={err.discount}
                            /> 
                        </div> 

                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status} 
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            />
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Mark Trusted"
                                value={formData.isTrusted} 
                                onChange={(e) => setFormData({...formData,isTrusted: e.target.value})}
                                options={["No","Yes"]}
                                values={["No","Yes"]}
                            /> 
                        </div> 
                        
                    </div>
 

                    <Divider />

                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfPartner);